import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

export function Login() {
  const { login, API, setUser } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await login(form.email, form.password); toast.success("Welcome back"); nav("/"); }
    catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
  };
  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <h1 className="font-display text-4xl mb-6">SIGN IN</h1>
      <button onClick={googleLogin} className="btn-outline w-full mb-4" data-testid="google-login-btn">CONTINUE WITH GOOGLE</button>
      <div className="text-center font-mono text-xs text-[var(--ink-2)] my-4">— OR —</div>
      <form onSubmit={submit} className="space-y-4">
        <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="input-field" data-testid="email-input"/>
        <input required type="password" placeholder="Password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="input-field" data-testid="password-input"/>
        <button className="btn-primary w-full" data-testid="submit-login">SIGN IN</button>
      </form>
      <p className="font-mono text-xs mt-6 text-center">No account? <Link to="/signup" className="underline">CREATE ONE</Link></p>
    </div>
  );
}

export function Signup() {
  const { signup } = useApp();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await signup(form.email, form.password, form.name); toast.success("Account created"); nav("/"); }
    catch (err) { toast.error(err.response?.data?.detail || "Signup failed"); }
  };
  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="signup-page">
      <h1 className="font-display text-4xl mb-6">CREATE ACCOUNT</h1>
      <form onSubmit={submit} className="space-y-4">
        <input required placeholder="Full Name" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} className="input-field" data-testid="name-input"/>
        <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} className="input-field" data-testid="email-input"/>
        <input required type="password" placeholder="Password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} className="input-field" data-testid="password-input"/>
        <button className="btn-primary w-full" data-testid="submit-signup">SIGN UP</button>
      </form>
      <p className="font-mono text-xs mt-6 text-center">Have an account? <Link to="/login" className="underline">SIGN IN</Link></p>
    </div>
  );
}

export function AuthCallback() {
  const { API, checkAuth } = useApp();
  const nav = useNavigate();
  const ran = React.useRef(false);
  useEffect(() => {
    if (ran.current) return; ran.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    if (!sid) { nav("/login"); return; }
    axios.post(`${API}/auth/google-session`, {}, { headers: { "X-Session-ID": sid } })
      .then(r => {
        if (r.data.token) localStorage.setItem("lcw_token", r.data.token);
        window.history.replaceState(null, "", "/");
        checkAuth().then(() => nav("/"));
      })
      .catch(() => nav("/login"));
  }, []);
  return <div className="p-20 text-center font-mono">SIGNING YOU IN...</div>;
}
